// TODO(igor): Unify and move score calculation to BE https://coursera.atlassian.net/browse/CP-6072
const getAttemptScore = (evaluation?: {
  score?: number;
  maxScore?: number;
  extraCreditScore?: number;
}): number | undefined => {
  if (!evaluation || !evaluation.maxScore) {
    return undefined;
  }
  const { score, maxScore, extraCreditScore } = evaluation;
  const totalScore = (score || 0) + (extraCreditScore || 0);
  const attemptScore = totalScore / maxScore;
  // If there are 8 parts a learner could score 1/8 -> 0.125, so we want to round till 4 decimal places
  // in case of a percentage representation needs to be in decimal. Eg: .1255 -> 12.55%
  // also 0.7999 -> 0.8
  return +attemptScore.toFixed(4);
};

export default getAttemptScore;
